import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.18 Case 18</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_118"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, eight, or 118.
                This is a negative case. Beginning at the level of the
                cerebellum and moving superiorly, we enter into the temporal and
                occipital regions. Distinct white matter tracts are easily
                visualized on the left-hand side as well as on the right-hand
                side. The normal gray-white contrast is preserved throughout the
                temporal and occipital regions. There is no increase in activity
                within the gray matter. This pattern continues throughout the
                temporal and occipital regions. As we continue moving
                superiorly, we enter into the frontal cortices, seen here. Once
                again, distinct white matter, finger-like projections are
                delineated in the left and right frontal cortices. Less intense
                activity is seen in the surrounding gray matter, identified here
                as well as here. White matter tracts are also delineated, moving
                from the front of the brain to the back of the brain, on the
                left-hand side as well as on the right-hand side. Continuing to
                move superiorly and entering into the parietal region, once
                again white matter tracts are delineated on the right and the
                left as they course from the front to the back of the brain. In
                the medial parietal region, seen here, no increase in activity
                is seen in the midline to suggest increased gray-matter
                activity. After reviewing all the slices within this scan, it is
                clear that there is normal gray-white contrast throughout all
                regions. Therefore, this case is negative. If you called this
                case positive, you may want to review the scan once again in the
                MIM Viewer.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-17"
          nextLesson="/module-3/module-3-0-19"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2068911702&entry_id=1_n0j4y28q&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_n0j4y28q"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
